"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TYPES = exports.IMG_REGEX = exports.ASSET_TYPE = void 0;
var ASSET_TYPE = {
  script: 'script',
  style: 'style',
  font: 'font',
  image: 'image'
};
exports.ASSET_TYPE = ASSET_TYPE;
var TYPES = {
  http: 'http',
  js: '.js',
  css: '.css',
  src: 'src',
  href: 'href',
  stylesheet: 'link[rel="stylesheet"]',
  link: 'link',
  prefetch: 'prefetch',
  img: 'img'
};
exports.TYPES = TYPES;
var IMG_REGEX = /.(gif|jpe?g|png|webp)$/i;
exports.IMG_REGEX = IMG_REGEX;